import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserArrangeTable = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解7：桌次编排
          </Title>
          <div className="text-lg">
            <p>一、点击桌次编排→操作，出现菜单列表：</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/1.png" alt="" />
            </div>
            <p>1、更改桌名</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/2.png" alt="" />
            </div>
            <p>桌名前缀：定义桌号的前缀名。</p>
            <p>跳过编号：将需要跳过的数字填入，每个数字之间用空格隔开，该数字不会用于桌号编排。</p>
            <p>2、批量创建桌次</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/3.png" alt="" />
            </div>
            <p>数量：定义需要创建的桌数。首次定义时，系统会根据参赛队伍，提供默认桌数。</p>
            <p>桌名前缀：定义桌号的前缀名。</p>
            <p>3、手动安排</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/4.png" alt="" />
            </div>
            <p>桌次：选择已创建的桌号。</p>
            <p>1号队：选择已录入信息并完成签到，未被编排的队伍，方位为该桌的东西。</p>
            <p>2号队：选择已录入信息并完成签到，未被编排的队伍，方位为该桌的南北。</p>
            <p>轮次：选择参赛的轮次。</p>
            <p>4、一键编排</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/5.png" alt="" />
            </div>
            <p>轮次：选择需编排的轮次。</p>
            <p>选手匹配方式：选择分数，则按高分对高分、低分对低分编排；选择随机，则由系统随机编排；选择编号临近，则按录入的顺序邻近编排。</p>
            <p>
              同团体不碰：定义同团体的队伍是否相遇。有回避要求的，必须事先为队伍指定团体。团体循环，用于团体比赛，采取团体之间循环的方式编排；相遇团体之间的选手对阵，按选手匹配方式的定义编排。
            </p>
            <p>打乱桌次顺序：定义是否打乱桌次编排。用于按分数编排时，正常情况第一名和第二名在 1 号桌；如果打乱桌次顺序，那么第一名和第二名在同桌，但不一定在 1 号桌。</p>
            <p>按方位不重复：选择不重时，本轮方位与上轮不同。</p>
            <p>一定小编号坐东西方：定义是否固定让编号小的队伍坐东西方。</p>
            <p>
              严格模式：选择严格模式时，以不相遇原则为主，其他原则为辅，若按正常顺序无法匹配时，会重新规划编排，确保同团体的队伍不相遇。选择宽松模式时，按正常顺序编排后，若排名末尾的队伍无法匹配，
              则认定大部分编排已经正常，末尾的队伍因成绩最差，即使同属一个团体，也将其直接编排。
            </p>
            <p>5、交换座次</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/6.png" alt="" />
            </div>
            <p>用于交换队伍的座位，分别选择需要交换位置的 2 支队伍，点确定。</p>
            <p>6、删除本轮编排</p>
            <p>必须先选择轮次，才能删除该轮次的编排。若该轮次已完成结算，则无法删除。</p>
            <p>7、一键结算</p>
            <p>详见成绩录入。</p>
            <p>8、编排展示</p>
            <p>显示本轮编排情况。</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/7.png" alt="" />
            </div>
            <p>9、轮空补齐</p>
            <p>遇有轮空选手时，如果添加了新的参赛选手，可将新的选手自动补到轮空的位置。</p>
            <p>10、导出</p>
            <div className="my-4">
              <Image src="/manual/arrange_table/8.png" alt="" />
            </div>
            <p>选择需要的内容以 Excel表格格式和 PDF 格式导出。</p>
            <p>导出比赛结果可查看详细的比赛数据。</p>
            <p>11、下载成绩单</p>
            <p>详见统计排名。</p>
            <p>二、删除桌次里的队伍</p>
            <p>点击队伍所在桌次上的清理，可以将该桌全部选手删除，但桌号仍被保留，被删除的选手可被重新安排桌次。完成结算的桌次无法清理。</p>
            <p>三、删除桌次</p>
            <p>创建桌次后，没有选手信息的桌次可以删除，点击需要删除桌次上的删除，可以删除该桌次。</p>
            <p>四、新增桌次和选手</p>
            <p>使用批量创建桌次功能，可在任意一轮增加桌次，然后使用手动安排功能添加选手。增加桌次后可补录成绩，也可不录。补录的成绩用于统计汇总，不影响已编排好的对阵。</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserArrangeTable as any, {
  title: '桌次编排 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统桌次编排:更改桌名前缀、跳过编号、批量创建桌次、每轮一键编排对阵与调整座位。',
})

export default UserArrangeTable
